module.exports = __webpack_public_path__ + "static/media/times-icon.bf4ce22c.svg";